import { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import ProfileDropdown from "../profiledropdown_v2/ProfileDropdown";
import UnityLogo from "../../assets/icons/unity_logo_white.png";
import {
  Heart,
  ShoppingCart,
  LayoutDashboard,
  Headphones,
  MapPin,
  User,
  ChevronDown,
  Search,
} from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ApiService from "../../components/Api_services";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose.js";
import FallbackImg from "../FallbackImg";
import {
  ACCESS_KEYS,
  REDIRECT_LOGIN_URL,
  REDIRECT_SWITCH_USER_URL,
} from "../../constants";
import { hasAccess } from "../../utils/Permission";
import ContactUs from "../contactus/ContactUs.js";

const Navbarv2 = ({
  // categoryDropdownOpen,
  // setCategoryDropdownOpen,
  // selectedCategoryCode,
  // setSelectedCategoryCode,
  cartCount,
  wishlistCount,
  fetchCounts,
}) => {
  const [promotionCount, setPromotionCount] = useState(0);
  const [newArrivalCount, setNewArrivalCount] = useState(0);
  const [comingSoonCount, setComingSoonCount] = useState(0);
  const [openProfile, setOpenProfile] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  // const [cartCount, setCartCount] = useState(0);
  // const [wishlistCount, setWishlistCount] = useState(0);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [searchValue, setSearchValue] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const supportDropdownRef = useRef(null);
  const moreDropdownRef = useRef(null);
  const navigate = useNavigate();
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showContactUs, setShowContactUs] = useState(false);
  const inputRef = useRef(null);
  const profileRef = useRef(null);
  const location = useLocation();

  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;

  const canViewProductNav =
    !is_subuser ||
    hasAccess(sub_role, ACCESS_KEYS.MY_ORDER || ACCESS_KEYS.HOME);
  const canViewRepair = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.REPAIR);
  const companyName = user?.company_name || "";

  useEffect(() => {
    async function fetchCounts() {
      try {
        const res = await ApiService.getNewArrivalPromotionCount();
        setPromotionCount(res.promotion_total || 0);
        setNewArrivalCount(res.new_arrival_total || 0);
        setComingSoonCount(res.coming_soon_total || 0);
      } catch (e) {
        setPromotionCount(0);
        setNewArrivalCount(0);
        setComingSoonCount(0);
      }
    }
    fetchCounts();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchValue.trim()) {
      navigate(
        `/productlist?search=${encodeURIComponent(searchValue.trim())}&page=1`,
      );
      setOpenDropdown(null);
    }
  };

  const SupportDropdown = ({ open }) => (
    <>
      {open && <div className="custom-dropdown-overlay_v2" />}
      <div className={`simple-dropdown_v2 ${open ? "show" : ""}`}>
        <ul>
          <div
            style={{
              opacity: canViewRepair ? 1 : 0.5,
              cursor: canViewRepair ? "pointer" : "not-allowed",
              width: "100%",
              display: "flex",
            }}
            title={canViewRepair && isAuthenticated ? "" : "No permission"}
          >
            {canViewRepair && isAuthenticated ? (
              <Link to="newrequest">
                <li>
                  <Headphones size={16} />
                  <div>Service Request</div>
                </li>
              </Link>
            ) : (
              <Link
                to="newrequest"
                style={{
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              >
                <li>
                  <Headphones size={16} />
                  <div>Service Request</div>
                </li>
              </Link>
            )}
          </div>
          <Link to="brandservicecenter">
            <li>
              <MapPin size={16} />
              <div>Service Center Locations</div>
            </li>
          </Link>
        </ul>
      </div>
    </>
  );

  const MoreDropdown = ({ open }) => (
    <>
      {open && <div className="custom-dropdown-overlay" />}
      <div className={`simple-dropdown_v2 ${open ? "show" : ""}`}>
        <ul>
          <Link to="/aboutus">
            <li>
              <div>About Us</div>
            </li>
          </Link>
          <div style={{ width: "100%", display: "flex" }}>
            <li onClick={() => setShowContactUs(true)}>Contact Use</li>
          </div>
          {/* Disabled FAQ with tooltip */}
          <div style={{ width: "100%", display: "flex" }}>
            <li className="faq-li" onClick={(e) => e.preventDefault()}>
              <div>FAQ</div>
              <span className="faq-tooltip">Coming Soon</span>
            </li>
          </div>
          <Link to="/privacypolicy">
            <li>
              <div>Privacy Policy</div>
            </li>
          </Link>
          <Link to="refundreturnpolicy">
            <li>
              <div>Refund & Return Policy</div>
            </li>
          </Link>
          <Link to="/termsconditions">
            <li>
              <div>Terms & Conditions</div>
            </li>
          </Link>
        </ul>
      </div>
    </>
  );

  useEffect(() => {
    setOpenProfile(false);
  }, [isAuthenticated]);

  // useEffect(() => {
  //   if (isAuthenticated && localStorage.getItem("access_token")) {
  //     fetchCounts();
  //   } else {
  //     setCartCount(0);
  //     setWishlistCount(0);
  //   }
  // }, [isAuthenticated, user]);

  // const fetchCounts = async () => {
  //   const accessToken = localStorage.getItem("access_token");

  //   if (!accessToken) {
  //     return;
  //   }

  //   try {
  //     const cartResponse = await ApiService.getTotalCart({});

  //     if (cartResponse?.status === 200) {
  //       const cartTotal = cartResponse.data["Results Total Cart"] || 0;
  //       setCartCount(cartTotal);
  //     }

  //     const wishlistResponse = await ApiService.getCountAvailableWishlistItem(
  //       {}
  //     );

  //     if (wishlistResponse?.status === 200) {
  //       const wishlistTotal =
  //         wishlistResponse.data.available_wishlist_items || 0;
  //       setWishlistCount(wishlistTotal);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching counts:", error);
  //     setCartCount(0);
  //     setWishlistCount(0);
  //   }
  // };

  const toggleProfile = () => {
    setOpenProfile((prev) => !prev);
  };

  const toggleCategory = () => {
    setOpenDropdown((prev) => (prev === "category" ? null : "category"));
    // setCategoryDropdownOpen((prev) => !prev);
    // setCategoryDropdownOpen(false); // if setCategoryDropdownOpen is always "true", the below useEffect cannot run to open the dropdown
  };

  // Call toggleCategory when categoryDropdownOpen becomes true
  // useEffect(() => {
  //   if (categoryDropdownOpen) {
  //     toggleCategory();
  //   }
  // }, [categoryDropdownOpen]);

  const toggleBrand = () => {
    setOpenDropdown((prev) => (prev === "brand" ? null : "brand"));
    // setCategoryDropdownOpen(false);
  };

  const toggleSupport = () => {
    setOpenDropdown((prev) => (prev === "support" ? null : "support"));
    // setCategoryDropdownOpen(false);
  };

  const toggleMore = () => {
    setOpenDropdown((prev) => (prev === "more" ? null : "more"));
    // setCategoryDropdownOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close ProfileDropdown when clicking outside
  useEffect(() => {
    if (!openProfile) return;

    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setOpenProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openProfile]);

  // Close SupportDropdown when clicking outside
  useEffect(() => {
    if (openDropdown !== "support") return;
    const handleClickOutside = (event) => {
      if (
        supportDropdownRef.current &&
        !supportDropdownRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown]);

  // Close MoreDropdown when clicking outside
  useEffect(() => {
    if (openDropdown !== "more") return;
    const handleClickOutside = (event) => {
      if (
        moreDropdownRef.current &&
        !moreDropdownRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown]);

  return (
    <div className={`navbar_v2${isScrolled ? " navbar-fixed" : ""}`}>
      <div style={{ background: "#7D9274" }}>
        <div className="navbar-container">
          <div className="navbar1_v2">
            <div className="home-container">
              <Link to="/" style={{ height: "50px" }}>
                <FallbackImg
                  src={UnityLogo}
                  alt="unitylogo"
                  style={{ width: "150px", objectFit: "cover" }}
                />
              </Link>
            </div>

            <div className="searchbar-container">
              <form
                className="searchbar_v2"
                onSubmit={handleSearch}
                autoComplete="off"
              >
                <input
                  type="text"
                  placeholder="Search by item code or product name..."
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className={searchValue ? "with-remove" : "no-remove"}
                  ref={inputRef}
                  autoComplete="off"
                  name="global-search-input"
                  spellCheck={false}
                />
                {searchValue && (
                  <div
                    className="searchbar-remove_v2"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setSearchValue("");
                      if (location.pathname === "/productlist") {
                        const newParams = new URLSearchParams(
                          window.location.search,
                        );
                        newParams.delete("search");
                        newParams.set("page", "1");
                        navigate(`/productlist?${newParams.toString()}`);
                      }
                      inputRef.current && inputRef.current.blur();
                    }}
                  >
                    &#x2715;
                  </div>
                )}
                <button type="submit">
                  <Search size={16} className="searchbar-icon_v2" />
                </button>
              </form>
            </div>

            <div className="profile-container">
              <ul>
                <li>
                  {!localStorage.getItem("access_token") ? (
                    <div
                      className="navbar-icon-container"
                      style={{
                        cursor: canViewProductNav ? "pointer" : "not-allowed",
                        opacity: canViewProductNav ? 1 : 0.5,
                      }}
                      title={canViewProductNav ? "" : "No permission"}
                      onClick={() =>
                        canViewProductNav && setShowLoginPrompt(true)
                      }
                    >
                      <Heart size={25} style={{ color: "#ffffff" }} />
                      <span className="navbar-tooltip-text">My Wishlist</span>
                      {/* {wishlistCount > 0 && (
                        <div className={`navbar-unread-dot show`} />
                      )} */}
                      {wishlistCount > 0 && (
                        <div
                          className={`navbar-unread_v2${
                            wishlistCount > 0 ? " show" : ""
                          }`}
                        >
                          {wishlistCount}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      className="navbar-icon-container"
                      style={{
                        cursor: canViewProductNav ? "pointer" : "not-allowed",
                        opacity: canViewProductNav ? 1 : 0.5,
                      }}
                      title={canViewProductNav ? "" : "No permission"}
                      onClick={() => {
                        if (!canViewProductNav) return;
                        navigate("/mywishlist");
                      }}
                    >
                      <Heart size={25} style={{ color: "#ffffff" }} />
                      <span className="navbar-tooltip-text">My Wishlist</span>
                      {/* {wishlistCount > 0 && (
                        <div className={`navbar-unread-dot show`} />
                      )} */}
                      {wishlistCount > 0 && (
                        <div
                          className={`navbar-unread_v2${
                            wishlistCount > 0 ? " show" : ""
                          }`}
                        >
                          {wishlistCount}
                        </div>
                      )}
                    </div>
                  )}
                </li>
                <li>
                  {!localStorage.getItem("access_token") ? (
                    <div
                      className="navbar-icon-container"
                      style={{
                        cursor: canViewProductNav ? "pointer" : "not-allowed",
                        opacity: canViewProductNav ? 1 : 0.5,
                      }}
                      title={canViewProductNav ? "" : "No permission"}
                      onClick={() =>
                        canViewProductNav && setShowLoginPrompt(true)
                      }
                    >
                      <ShoppingCart size={25} style={{ color: "#ffffff" }} />
                      <span className="navbar-tooltip-text">
                        My Shopping Cart
                      </span>
                      {cartCount > 0 && (
                        <div
                          className={`navbar-unread_v2${
                            cartCount > 0 ? " show" : ""
                          }`}
                        >
                          {cartCount}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      className="navbar-icon-container"
                      style={{
                        cursor: canViewProductNav ? "pointer" : "not-allowed",
                        opacity: canViewProductNav ? 1 : 0.5,
                      }}
                      title={canViewProductNav ? "" : "No permission"}
                      onClick={() => {
                        if (!canViewProductNav) return;
                        navigate("/myshoppingcart");
                      }}
                    >
                      <ShoppingCart size={25} style={{ color: "#ffffff" }} />
                      <span className="navbar-tooltip-text">
                        My Shopping Cart
                      </span>
                      {cartCount > 0 && (
                        <div
                          className={`navbar-unread_v2${
                            cartCount > 0 ? " show" : ""
                          }`}
                        >
                          {cartCount}
                        </div>
                      )}
                    </div>
                  )}
                </li>
                {localStorage.getItem("access_token") && (
                  <li>
                    <div
                      className="navbar-icon-container"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        (window.location.href = REDIRECT_SWITCH_USER_URL)
                      }
                    >
                      <LayoutDashboard size={25} style={{ color: "#ffffff" }} />
                      <span className="navbar-tooltip-text">
                        Navigate to Dashboard
                      </span>
                    </div>
                  </li>
                )}

                <li>
                  {isAuthenticated ? (
                    <div
                      className="loginprofile_v2"
                      onClick={toggleProfile}
                      ref={profileRef}
                    >
                      {user?.profile_photo_url ? (
                        <FallbackImg
                          src={user.profile_photo_url + "?t=" + Date.now()}
                          alt="profile"
                          width="25"
                          height="25"
                          className="loginprofile-avatar"
                          style={{ borderRadius: "50%", objectFit: "cover" }}
                        />
                      ) : (
                        <User size={25} style={{ color: "#ffffff" }} />
                      )}
                      <div className="loginprofile-info_v2">
                        <div className="loginprofile-comp-container_v2">
                          <span className="truncate-company">
                            {companyName}
                          </span>
                        </div>
                        <div className="loginprofile-subuser-container_v2">
                          {/* <span className="truncate-name">{user?.name}</span> */}
                          <span className="truncate-name_v2">{user?.name}</span>
                        </div>
                      </div>
                      <div className="loginprofile-caret">
                        <ChevronDown
                          size={16}
                          className={openProfile ? "rotate" : ""}
                        />
                      </div>
                      <ProfileDropdown
                        open={openProfile}
                        fetchCounts={fetchCounts}
                      />
                    </div>
                  ) : (
                    <a
                      href={REDIRECT_LOGIN_URL}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <User size={25} style={{ color: "#ffffff" }} />
                      <span style={{ color: "white" }}>
                        Login /<br />
                        Register
                      </span>
                    </a>
                  )}
                </li>

                {showLoginPrompt && (
                  <MultiPurpose
                    title="Login Required"
                    message="You need to login to access this feature."
                    yesText="Login"
                    noText="Cancel"
                    showYesLink={true}
                    yesLink={REDIRECT_LOGIN_URL}
                    onNo={() => setShowLoginPrompt(false)}
                    onClose={() => setShowLoginPrompt(false)}
                  />
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div style={{ background: "#283E24" }}>
        <div className="navbar-container">
          <div className="navbar2_v2">
            <ul>
              <li
                className={
                  location.pathname === "/explorebrand"
                    ? "navbar-link-active_v2"
                    : "navbar-link_v2"
                }
                style={{
                  opacity: canViewProductNav ? 1 : 0.5,
                  cursor: canViewProductNav ? "pointer" : "not-allowed",
                }}
                title={canViewProductNav ? "" : "No permission"}
                onClick={(e) => {
                  if (!canViewProductNav) {
                    e.preventDefault();
                    return;
                  }
                  navigate("/explorebrand");
                }}
              >
                <span
                  style={{
                    color: "white",
                  }}
                >
                  Brands
                </span>
              </li>

              <li
                className={
                  location.pathname === "/exploreproduct"
                    ? "navbar-link-active_v2"
                    : "navbar-link_v2"
                }
                style={{
                  opacity: canViewProductNav ? 1 : 0.5,
                  cursor: canViewProductNav ? "pointer" : "not-allowed",
                }}
                title={canViewProductNav ? "" : "No permission"}
                onClick={(e) => {
                  if (!canViewProductNav) {
                    e.preventDefault();
                    return;
                  }
                  navigate("/exploreproduct");
                }}
              >
                <span
                  style={{
                    color: "white",
                  }}
                >
                  Products
                </span>
              </li>

              {/* //bundled similar nav items together */}
              {/* <li
                className={
                  (location.pathname + location.search).includes(
                    "/productlist?filter_type=bundle"
                  )
                    ? "navbar-link-active_v2"
                    : ""
                }
                style={{
                  // opacity: canViewProductNav && isAuthenticated ? 1 : 0.5,
                  cursor:"pointer"
                }}
                // title={
                //   canViewProductNav && isAuthenticated ? "" : "No permission"
                // }
                onClick={(e) => {
                  // if (!canViewProductNav || !isAuthenticated) {
                  //   e.preventDefault();
                  //   return;
                  // }
                  navigate("/productlist?filter_type=bundle");
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span style={{
                  color: "white"
                }}>Bundle</span>
                  {/* <div
                    className={`navbar-unreadtag_v2${
                      comingSoonCount > 0 && isAuthenticated ? " show" : ""
                    }`}
                  ></div> */}
              {/* </div>
              </li> */}

              <li
                className={
                  (location.pathname + location.search).includes(
                    "/productlist?filter_type=coming_soon",
                  )
                    ? "navbar-link-active_v2"
                    : "navbar-link_v2"
                }
                style={{
                  opacity: canViewProductNav && isAuthenticated ? 1 : 0.5,
                  cursor:
                    canViewProductNav && isAuthenticated
                      ? "pointer"
                      : "not-allowed",
                }}
                title={
                  canViewProductNav && isAuthenticated ? "" : "No permission"
                }
                onClick={(e) => {
                  if (!canViewProductNav || !isAuthenticated) {
                    e.preventDefault();
                    return;
                  }
                  navigate("/productlist?filter_type=coming_soon");
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span
                    style={{
                      color: "white",
                    }}
                  >
                    Coming Soon
                  </span>
                  <div
                    className={`navbar-unreadtag_v2${
                      comingSoonCount > 0 && isAuthenticated ? " show" : ""
                    }`}
                  ></div>
                </div>
              </li>
              <li
                className={
                  (location.pathname + location.search).includes(
                    "/productlist?filter_type=new_arrival",
                  )
                    ? "navbar-link-active_v2"
                    : "navbar-link_v2"
                }
                style={{
                  opacity: canViewProductNav && isAuthenticated ? 1 : 0.5,
                  cursor:
                    canViewProductNav && isAuthenticated
                      ? "pointer"
                      : "not-allowed",
                }}
                title={
                  canViewProductNav && isAuthenticated ? "" : "No permission"
                }
                onClick={(e) => {
                  if (!canViewProductNav || !isAuthenticated) {
                    e.preventDefault();
                    return;
                  }
                  navigate("/productlist?filter_type=new_arrival");
                }}
              >
                {/* <Link to="/productlist?filter_type=new_arrival">New Arrival</Link> */}
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span
                    style={{
                      color: "white",
                    }}
                  >
                    New Arrivals
                  </span>
                  <div
                    className={`navbar-unreadtag_v2${
                      newArrivalCount > 0 && isAuthenticated ? " show" : ""
                    }`}
                  ></div>
                </div>
              </li>

              <li
                className={
                  (location.pathname + location.search).includes(
                    "/productlist?filter_type=promotion",
                  )
                    ? "navbar-link-active_v2"
                    : "navbar-link_v2"
                }
                style={{
                  opacity: canViewProductNav && isAuthenticated ? 1 : 0.5,
                  cursor:
                    canViewProductNav && isAuthenticated
                      ? "pointer"
                      : "not-allowed",
                }}
                title={
                  canViewProductNav && isAuthenticated ? "" : "No permission"
                }
                onClick={(e) => {
                  if (!canViewProductNav || !isAuthenticated) {
                    e.preventDefault();
                    return;
                  }
                  navigate("/productlist?filter_type=promotion");
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <span
                    style={{
                      color: "white",
                    }}
                  >
                    Promotions
                  </span>
                  <div
                    className={`navbar-unreadtag_v2${
                      promotionCount > 0 && isAuthenticated ? " show" : ""
                    }`}
                  ></div>
                </div>
              </li>

              <li
                className={
                  (location.pathname + location.search).includes(
                    "/productlist?filter_type=package",
                  )
                    ? "navbar-link-active_v2"
                    : "navbar-link_v2"
                }
                style={{
                  opacity: canViewProductNav && isAuthenticated ? 1 : 0.5,
                  cursor:
                    canViewProductNav && isAuthenticated
                      ? "pointer"
                      : "not-allowed",
                }}
                title={
                  canViewProductNav && isAuthenticated ? "" : "No permission"
                }
                onClick={(e) => {
                  if (!canViewProductNav || !isAuthenticated) {
                    e.preventDefault();
                    return;
                  }
                  navigate("/productlist?filter_type=package");
                }}
              >
                <span
                  style={{
                    color: "white",
                  }}
                >
                  Packages
                </span>
              </li>

              {/* <li>
                <Link to="/preorder">Pre-Order</Link>
              </li> */}
              <li
                className={
                  location.pathname === "/brandservicecenter" ||
                  location.pathname === "/newrequest"
                    ? "support-li navbar-link-active_v2"
                    : "support-li"
                }
                onClick={() =>
                  setOpenDropdown(openDropdown === "support" ? null : "support")
                }
                ref={supportDropdownRef}
              >
                <div className="dropdownlist">
                  <span
                    style={{
                      color: "white",
                    }}
                  >
                    Support
                  </span>
                  <ChevronDown
                    size={16}
                    color={"#ffffff"}
                    className={openDropdown === "support" ? "rotate" : ""}
                  />
                </div>
                <SupportDropdown open={openDropdown === "support"} />
              </li>
              {/* <li
                className={
                  location.pathname === "/aboutus" ||
                  location.pathname === "/privacypolicy" ||
                  location.pathname === "/refundreturnpolicy" ||
                  location.pathname === "/termsconditions"
                    ? "more-li navbar-link-active_v2"
                    : "more-li"
                }
                onClick={() =>
                  setOpenDropdown(openDropdown === "more" ? null : "more")
                }
                ref={moreDropdownRef}
              >
                <div className="dropdownlist">
                  <span
                    style={{
                      color: "white",
                    }}
                  >
                    More
                  </span>
                  <FallbackImg
                    src={ArrowDown}
                    alt="arrow"
                    width="15"
                    height="15"
                    className={openDropdown === "more" ? "rotate" : ""}
                  />
                </div>
                <MoreDropdown open={openDropdown === "more"} />
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      {showContactUs && <ContactUs onClose={() => setShowContactUs(false)} />}
    </div>
  );
};

export default Navbarv2;
